const serverHost = "https://admin.brevistay.com/adex";
const staging = "https://adex.stage.sandbox.brevistay.com";
const local = "http://localhost";
const preStage2 = "https://adex.intgr.sandbox.brevistay.com"; //prestage 2

export const showEnvironment = false; // set to true to show the environment in the console

// DEBUG VALUES FOR POINTING SERVERS

// 0 -- > serverHost(Prod)
// 1 -- > staging(staging)
// 2 -- > local


export const debug = 1; // CHANGE THIS TO 0 before deploying to live server
//(api,internalRoute)=> 0->(LIVE, LIVE) 1->(TEST,STAGING) 2->(TEST,LOCALHOST)
const HOST = debug === 0 ? serverHost : debug === 1 ? staging : debug === 2 ? local : preStage2;

export const DB_DATE_TIME_FORMAT = "YYYY-MM-DD hh:mm:ss";
export const HOTEL_API = HOST + "/wss/hotel";
export const SUPER_ADMIN_API = HOST + "/api/sa";
export const FINANCE = HOST + "/finance";
export const MARKETING = HOST + "/marketing";
export const USER_DATA = "user_data";
export const PAYMENT = HOST + "/payments";
export const SELECTED_ROOM_HOTEL_ID = "selected_room_hotel_id";
export const SELECTED_HOTEL_ID = "selected_hotel_id";
export const SELECTED_HOTEL_NAME = "selected_hotel_name";
export const SELECTED_HOTEL_ACTIVE_CHANNEL_MANAGER = "selected_hotel_active_channel_manager";
export const ANALYTICS = HOST + "/analytics";
export const OTA_API = HOST + "/ota";
export const IPL = HOST + "/ipl";
export const SITE_IMG_BASE_URL = debug==0 ? "https://images.brevistay.com/" : "https://images.sandbox.brevistay.com/";
export const CM_LOGO = {
      STAAH:
        `${SITE_IMG_BASE_URL}extranet-new/STAAH.png`,
      AXISROOM:
        `${SITE_IMG_BASE_URL}extranet-new/AXISROOMSLOGO.jpg`,
      RESAVENUE:
        `${SITE_IMG_BASE_URL}extranet-new/RESAVENUELOGO.jpg`,
      EZEETECH:
        `${SITE_IMG_BASE_URL}extranet-new/EZEETECHLOGO.jpg`,
      RATEGAIN:
        `${SITE_IMG_BASE_URL}extranet-new/RateGainLogo.png`,
      STAYFLEXI:
        `${SITE_IMG_BASE_URL}extranet-new/StayFlexiLogo.png`,
      MINIHOTELMAN:
        `${SITE_IMG_BASE_URL}extranet-new/MiniHotelMan.png`
    };

export const API_RESPONSE = {
  SESSION_ERROR: "401",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};
export const SESSION_ERROR = "session_error";
